import camelCase from "lodash/camelCase";
const files = require.context("./zh", false, /\.json$/i);
const modules = {};

files.keys().forEach((item) => {
  const name = camelCase(item.split('.')[1].replace('/',''));
  const fileModule = files(item);
  if (!fileModule) return;
  modules[name] = fileModule;
});


export default modules